import { get } from '../httpClient';

export const creditsAPI = {
  query: params => get('/api/credits/query', params),
};